<template>
    <div class="flex flex-row items-center md:w-1/3 sm:w-1/2 mx-auto justify-center mt-3">
      <span class="font-semibold text-xs">{{ $t('powered-by') }}</span>
      <img src="../../assets/images/URBO-City-logo.png" class="w-2/12 ml-3" alt="Urbo parking logo" />
    </div>
</template>